import { Badge } from "@/components/ui/badge";

/**
 * Badge visivo per la tipologia (modality) del corso.
 *  - Blu  → E-learning
 *  - Verde → Videoconferenza
 *  - Arancione → Aula
 */
const MAP = {
  elearning: { label: "E-learning", cls: "bg-blue-500 text-white hover:bg-blue-500" },
  "e-learning": { label: "E-learning", cls: "bg-blue-500 text-white hover:bg-blue-500" },
  videoconferenza: { label: "Videoconferenza", cls: "bg-emerald-500 text-white hover:bg-emerald-500" },
  aula: { label: "Aula", cls: "bg-orange-500 text-white hover:bg-orange-500" },
};

export default function ModalityBadge({ modality, className = "", testid }) {
  const key = String(modality || "").trim().toLowerCase();
  const cfg = MAP[key] || { label: modality || "—", cls: "bg-slate-500 text-white hover:bg-slate-500" };
  return (
    <Badge className={`${cfg.cls} ${className}`} data-testid={testid || `modality-badge-${key}`}>
      {cfg.label}
    </Badge>
  );
}

export const modalityPaymentCategory = (modality) => {
  const m = String(modality || "").trim().toLowerCase();
  if (m === "elearning" || m === "e-learning") return "elearning";
  if (m === "videoconferenza" || m === "aula") return "classroom";
  return "unknown";
};

export const cartPaymentCategory = (items) => {
  const cats = new Set();
  (items || []).forEach((it) => {
    const c = modalityPaymentCategory(it.modality);
    if (c !== "unknown") cats.add(c);
  });
  if (cats.size === 0) return "unknown";
  if (cats.size > 1) return "mixed";
  return [...cats][0];
};
